

document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('[data-hero-scroll], .hero__scroll');
  if (!btn) return;

  const hero = btn.closest('.hero') || document.querySelector('.hero');
  if (!hero) return;

  let node = hero.closest('.shopify-section') || hero;
  let next = node.nextElementSibling;
  while (next && next.getBoundingClientRect().height === 0) {
    next = next.nextElementSibling;
  }
  if (!next) return;

  const header = document.querySelector('.site-header');
  const offset = header ? header.getBoundingClientRect().height : 0;
  const top = next.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({
    top: top,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  });
});

function deactivateClone(clone) {
  clone.setAttribute('aria-hidden', 'true');
  clone.querySelectorAll('a, button, input, select, textarea, [tabindex]')
       .forEach(function (el) { el.setAttribute('tabindex', '-1'); });
}

function initProductCarousel(trackOrId) {
  var track = typeof trackOrId === 'string' ? document.getElementById(trackOrId) : trackOrId;
  if (!track || track.mainInit) return;
  track.mainInit = { destroy: function () {} };

  var origCards = Array.prototype.slice.call(track.querySelectorAll('.product-card'));
  var origCount = origCards.length;
  if (!origCount) return;

  var clones = origCards.map(function (card) {
    var clone = card.cloneNode(true);
    deactivateClone(clone);
    track.appendChild(clone);
    return clone;
  });

  var section  = track.closest('[data-carousel-scope]') || track.closest('section') || track.parentElement;
  var btnsPrev = section.querySelectorAll('.top-picks__arrow--prev');
  var btnsNext = section.querySelectorAll('.top-picks__arrow--next');

  var looping     = false;
  var target      = null;   /* where the rail is heading, null when at rest */
  var settleTimer = null;
  var observer    = null;

  function getStep() {
    return origCards[0].offsetWidth + (parseInt(getComputedStyle(track).gap) || 16);
  }

  function getPeriod() {
    var measured = clones[0].offsetLeft - origCards[0].offsetLeft;
    return measured > 0 ? measured : origCount * getStep();
  }

  function maxScroll() {
    return track.scrollWidth - track.clientWidth;
  }

  function syncMode() {
    clones.forEach(function (clone) { clone.hidden = false; });

    var canLoop = origCount > 1 && getPeriod() <= maxScroll() + 1;
    looping = canLoop;

    if (!canLoop) {
      clones.forEach(function (clone) { clone.hidden = true; });
      if (track.scrollLeft > maxScroll()) jump(maxScroll());
    }
    syncArrows();
  }

  function syncArrows() {
    var dead = !looping && maxScroll() <= 1;
    var atStart = !looping && track.scrollLeft <= 1;
    var atEnd   = !looping && track.scrollLeft >= maxScroll() - 1;

    btnsPrev.forEach(function (b) { b.hidden = dead; b.disabled = atStart; });
    btnsNext.forEach(function (b) { b.hidden = dead; b.disabled = atEnd; });
  }

  function from() {
    return target === null ? track.scrollLeft : target;
  }

  function smoothTo(pos) {
    pos = Math.max(0, Math.min(pos, maxScroll()));
    if (Math.abs(pos - track.scrollLeft) < 1) { target = null; return; }
    target = pos;
    track.style.scrollBehavior = 'smooth';
    track.scrollLeft = pos;
  }

  var wrapping = false;

  function jump(pos) {
    target = pos;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = pos;
    void track.offsetHeight;
  }

  function wrapThen(jumpTo, stepBy) {
    wrapping = true;
    jump(jumpTo);
    requestAnimationFrame(function () {
      wrapping = false;
      smoothTo(from() + stepBy);
    });
  }

  function scrollNext() {
    var step = getStep();
    if (!step) return;

    if (!looping) {
      smoothTo(Math.min(from() + step, maxScroll()));
      return;
    }

    var period = getPeriod();

    if (from() >= period - 1) {
      wrapThen(from() - period, step);
      return;
    }

    smoothTo(Math.min(from() + step, period));
  }

  function scrollPrev() {
    var step = getStep();
    if (!step) return;

    if (!looping) {
      smoothTo(Math.max(from() - step, 0));
      return;
    }

    var period = getPeriod();

    if (from() < step / 2) {
      wrapThen(from() + period, -step);
      return;
    }

    smoothTo(Math.max(from() - step, 0));
  }

  btnsPrev.forEach(function (btn) { btn.addEventListener('click', scrollPrev); });
  btnsNext.forEach(function (btn) { btn.addEventListener('click', scrollNext); });

  function onSettle() {
    if (wrapping) return;
    if (target !== null && Math.abs(track.scrollLeft - target) > Math.max(2, getStep() / 3)) return;
    target = null;
    track.style.scrollBehavior = '';

    if (looping) {
      var period = getPeriod();
      if (period > 0) {
        if (track.scrollLeft >= period) {
          jump(track.scrollLeft - period);
          target = null;
        } else if (track.scrollLeft < 0) {
          jump(track.scrollLeft + period);
          target = null;
        }
      }
    }
    syncArrows();
  }

  if ('onscrollend' in window) {
    track.addEventListener('scrollend', onSettle);
  } else {
    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(onSettle, 150);
    }, { passive: true });
  }

  syncMode();

  if ('ResizeObserver' in window) {
    observer = new ResizeObserver(syncMode);
    observer.observe(track);
  }
  window.addEventListener('resize', syncMode, { passive: true });
  window.addEventListener('load', syncMode);

  track.mainInit = {
    settle: function () {
      if (!track.offsetWidth) return;   /* hidden: nothing to measure */
      var base = origCards[0].offsetLeft;
      var at = target === null ? track.scrollLeft : target;
      var best = 0;
      var bestDist = Infinity;
      origCards.concat(clones).forEach(function (card) {
        if (card.hidden) return;
        var pos = card.offsetLeft - base;
        var dist = Math.abs(pos - at);
        if (dist < bestDist) { bestDist = dist; best = pos; }
      });
      jump(Math.min(best, maxScroll()));
      target = null;
      track.style.scrollBehavior = '';
    },
    destroy: function () {
      clearTimeout(settleTimer);
      window.removeEventListener('resize', syncMode);
      window.removeEventListener('load', syncMode);
      if (observer) { observer.disconnect(); observer = null; }
    }
  };
}

function initBrands(track) {
  if (!track || track.mainInit) return;

  const root    = track.closest('.brands') || track.parentElement;
  const btnPrev = root.querySelector('.brands__arrow--prev');
  const btnNext = root.querySelector('.brands__arrow--next');
  const t = window.t || function (key, fallback) { return fallback; };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let stopped = reduceMotion;
  let timer = null;
  let resumeTimer = null;
  let canScroll = true;
  const holds = { hover: false, focus: false, touch: false };

  function getVisible() {
    return window.innerWidth <= 767 ? 3 : 5;
  }

  function setItemWidths() {
    const visible = getVisible();
    const trackW  = track.offsetWidth;
    const itemW   = trackW / visible;
    track.querySelectorAll('.brands__item').forEach(function (el) {
      el.style.width = itemW + 'px';
    });

    if (itemW > 0) {
      const behavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = Math.round(track.scrollLeft / itemW) * itemW;
      track.style.scrollBehavior = behavior;
    }
  }

  function getItemStep() {
    const item = track.querySelector('.brands__item');
    return item ? item.offsetWidth : 200;
  }

  function scrollTo(pos) {
    track.style.scrollBehavior = 'smooth';
    track.scrollLeft = pos;
  }

  function step() {
    const w = getItemStep();
    const half = track.scrollWidth / 2;

    if (track.scrollLeft >= half - 1) {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft -= half;
      requestAnimationFrame(function () {
        track.style.scrollBehavior = 'smooth';
        track.scrollLeft += w;
      });
      return;
    }

    scrollTo(Math.min(track.scrollLeft + w, half));
  }

  function stepBack() {
    const w = getItemStep();
    const half = track.scrollWidth / 2;
    let prev = track.scrollLeft - w;
    if (prev < 0) {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = half;
      requestAnimationFrame(function () {
        track.style.scrollBehavior = 'smooth';
        track.scrollLeft = half - w;
      });
    } else {
      scrollTo(prev);
    }
  }

  let toggle = root.querySelector('[data-brands-toggle]');
  if (!toggle) {
    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'brands__toggle';
    toggle.setAttribute('data-brands-toggle', '');
    toggle.innerHTML = '<span class="brands__toggle-icon" aria-hidden="true"></span>';
    (track.closest('.brands__carousel-wrap') || track).insertAdjacentElement('afterend', toggle);
  }

  toggle.classList.add('brands__toggle--quiet');

  function syncToggle() {
    toggle.setAttribute('data-state', stopped ? 'paused' : 'playing');
    toggle.setAttribute('aria-label', stopped
      ? t('brands_play', 'Play brand logos')
      : t('brands_pause', 'Pause brand logos'));
  }

  function schedule() {
    clearInterval(timer);
    timer = null;
    if (canScroll && !stopped && !holds.hover && !holds.focus && !holds.touch) {
      timer = setInterval(step, 2500);
    }
  }

  function holdThenResume() {
    holds.touch = true;
    schedule();
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () {
      holds.touch = false;
      schedule();
    }, 8000);
  }

  function syncAffordances() {
    if (getComputedStyle(track).display !== 'flex') return;

    setItemWidths();

    const scrollable = track.clientWidth <= track.scrollWidth / 2 + 1;
    if (scrollable === canScroll) return;

    canScroll = scrollable;
    if (btnPrev) btnPrev.hidden = !canScroll;
    if (btnNext) btnNext.hidden = !canScroll;
    root.classList.toggle('brands--static', !canScroll);
    toggle.hidden = !canScroll;
    schedule();
  }

  toggle.addEventListener('click', function () {
    stopped = !stopped;
    syncToggle();
    schedule();
  });

  if (btnPrev) btnPrev.addEventListener('click', function () { holdThenResume(); stepBack(); });
  if (btnNext) btnNext.addEventListener('click', function () { holdThenResume(); step(); });

  track.addEventListener('mouseenter', function () { holds.hover = true; schedule(); });
  track.addEventListener('mouseleave', function () { holds.hover = false; schedule(); });
  track.addEventListener('focusin', function () { holds.focus = true; schedule(); });
  track.addEventListener('focusout', function (e) {
    if (track.contains(e.relatedTarget)) return;
    holds.focus = false;
    schedule();
  });
  track.addEventListener('touchmove', holdThenResume, { passive: true });

  syncToggle();
  syncAffordances();
  schedule();
  window.addEventListener('resize', syncAffordances, { passive: true });

  let observer = null;
  if ('ResizeObserver' in window) {
    observer = new ResizeObserver(syncAffordances);
    observer.observe(track);
  }
  window.addEventListener('load', syncAffordances);

  track.mainInit = {
    destroy: function () {
      stopped = true;
      clearInterval(timer);
      clearTimeout(resumeTimer);
      timer = null;
      window.removeEventListener('resize', syncAffordances);
      window.removeEventListener('load', syncAffordances);
      if (observer) { observer.disconnect(); observer = null; }
    }
  };
}

function initInstagram(wrap) {
  var track = wrap.querySelector('.instagram__track');
  if (!track || wrap.mainInit) return;

  var origItems = Array.from(track.querySelectorAll('.instagram__img-item'));
  var origCount = origItems.length;
  if (!origCount) return;
  origItems.forEach(function (item) {
    var clone = item.cloneNode(true);
    deactivateClone(clone);
    track.appendChild(clone);
  });

  function getStep() {
    return origItems[0].offsetWidth + (parseInt(getComputedStyle(track).gap) || 20);
  }

  function syncLoop() {
    var half = origCount * getStep();
    var jump = 0;
    if (wrap.scrollLeft >= half) {
      jump = -half;
    } else if (wrap.scrollLeft < 0) {
      jump = half;
    }
    if (!jump) return;
    var behavior = wrap.style.scrollBehavior;
    wrap.style.scrollBehavior = 'auto';
    wrap.scrollLeft += jump;
    wrap.style.scrollBehavior = behavior;
  }

  var isDown      = false;
  var startX      = 0;
  var scrollStart = 0;
  var settleTimer = null;

  wrap.style.cursor = 'grab';

  function onMouseDown(e) {
    isDown = true;
    wrap.style.cursor = 'grabbing';
    wrap.style.scrollSnapType = 'none'; /* free-drag while held */
    wrap.style.scrollBehavior = 'auto';
    startX      = e.pageX;
    scrollStart = wrap.scrollLeft;
    e.preventDefault();
  }

  function onMouseMove(e) {
    if (!isDown) return;
    wrap.scrollLeft = scrollStart - (e.pageX - startX);
  }

  function onMouseUp() {
    if (!isDown) return;
    isDown = false;
    wrap.style.cursor = 'grab';

    var step    = getStep();
    var snapped = Math.round(wrap.scrollLeft / step) * step;
    wrap.style.scrollBehavior = 'smooth';
    wrap.scrollLeft = snapped;

    setTimeout(function () {
      wrap.style.scrollSnapType = '';
      wrap.style.scrollBehavior = 'auto';
      syncLoop();
      wrap.style.scrollBehavior = '';
    }, 380);
  }

  function onScrollSettled() {
    if (!isDown) syncLoop();
  }

  function onScroll() {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(onScrollSettled, 150);
  }

  wrap.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
  if ('onscrollend' in window) {
    wrap.addEventListener('scrollend', onScrollSettled);
  } else {
    wrap.addEventListener('scroll', onScroll, { passive: true });
  }

  wrap.mainInit = {
    destroy: function () {
      clearTimeout(settleTimer);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }
  };
}

(function () {
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.product-swatch');
    if (sw) {
      var card = sw.closest('.product-card');
      if (card) {
        var swatches = Array.prototype.slice.call(card.querySelectorAll('.product-swatch'));
        var idx   = swatches.indexOf(sw);
        var full  = sw.dataset.img;
        var vid   = sw.dataset.variantId;
        var label = sw.getAttribute('aria-label');

        var pid   = card.getAttribute('data-product-id');
        var scope = card.closest('.top-picks__track') || card.parentElement;
        var twins = [card];
        if (pid && scope) {
          twins = Array.prototype.slice.call(
            scope.querySelectorAll('.product-card[data-product-id="' + pid + '"]'));
          if (twins.indexOf(card) === -1) twins.push(card);
        }

        twins.forEach(function (twin) {
          var buttons = twin.querySelectorAll('.product-swatch');

          if (full) {
            var img = twin.querySelector('.product-card__img');
            if (img) {
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
              img.src = full;
              img.alt = label || img.alt;
            }
          }

          if (vid) {
            twin.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
              var base = a.getAttribute('href').split('?')[0];
              a.setAttribute('href', base + '?variant=' + encodeURIComponent(vid));
            });
          }

          buttons.forEach(function (b, i) {
            var on = i === idx;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
      }
    }

    if (e.target.closest('.product-swatch__more')) {
      var btn = e.target.closest('.product-swatch__more');
      var popup = btn.parentElement.querySelector('.swatch-popup');
      if (!popup) return;
      popup.classList.toggle('is-open');
      popup.setAttribute('aria-hidden', popup.classList.contains('is-open') ? 'false' : 'true');
      btn.setAttribute('aria-expanded', popup.classList.contains('is-open'));
      e.stopPropagation();
      return;
    }

    if (e.target.closest('.swatch-popup__close')) {
      var closeBtn = e.target.closest('.swatch-popup__close');
      var popup = closeBtn.closest('.swatch-popup');
      var moreBtn = popup.parentElement.querySelector('.product-swatch__more');
      popup.classList.remove('is-open');
      if (moreBtn) moreBtn.setAttribute('aria-expanded', 'false');
      e.stopPropagation();
      return;
    }

    if (!e.target.closest('.swatch-popup')) {
      document.querySelectorAll('.swatch-popup.is-open').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
        var moreBtn = p.parentElement.querySelector('.product-swatch__more');
        if (moreBtn) moreBtn.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();

function initRelated(scope) {
  const section = scope.querySelector('[data-related][data-url]');
  if (!section || section.mainInit || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) return;
    observer.disconnect();

    fetch(section.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-related]');
        if (!fresh) return;
        section.innerHTML = fresh.innerHTML;
        const track = section.querySelector('.top-picks__track[id]');
        if (track) initProductCarousel(track);

        document.dispatchEvent(new CustomEvent('theme:products-appended', {
          detail: { cards: [section] }
        }));
      })
      .catch(function () { /* recommendations are optional */ });
  }, { rootMargin: '400px' });

  observer.observe(section);
  section.mainInit = { destroy: function () { observer.disconnect(); } };
}

function initProductTabs(root) {
  if (!root || root.tabsInit) return;
  root.tabsInit = true;
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  if (!tabs.length) return;

  function select(tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (!panel) return;
      var track = panel.querySelector('.top-picks__track');
      var settle = track && track.mainInit && track.mainInit.settle;
      if (!on && !panel.hidden && settle) settle();
      var showing = on && panel.hidden;
      panel.hidden = !on;
      if (showing && settle) requestAnimationFrame(function () { settle(); });
    });
    if (focus) tab.focus();
  }

  root.selectTab = function (tab) { select(tab, false); };

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { select(tab, false); });
    tab.addEventListener('keydown', function (e) {
      var next = null;
      if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') next = tabs[0];
      else if (e.key === 'End') next = tabs[tabs.length - 1];
      if (next) { e.preventDefault(); select(next, true); }
    });
  });
}

document.addEventListener('shopify:block:select', function (e) {
  var tab = e.target && e.target.closest ? e.target.closest('[role="tab"]') : null;
  var root = tab && tab.closest('[data-product-tabs]');
  if (root && root.selectTab) root.selectTab(tab);
});

function initSections(scope) {
  scope.querySelectorAll('[data-product-tabs]').forEach(function (root) { initProductTabs(root); });
  scope.querySelectorAll('.top-picks__track[id]').forEach(function (track) { initProductCarousel(track); });
  scope.querySelectorAll('.brands__track').forEach(function (track) { initBrands(track); });
  scope.querySelectorAll('.instagram__track-wrap').forEach(function (wrap) { initInstagram(wrap); });
  initRelated(scope);
}

initSections(document);

document.addEventListener('shopify:section:load', function (e) {
  initSections(e.target);
});

document.addEventListener('shopify:section:unload', function (e) {
  e.target.querySelectorAll('.brands__track, .instagram__track-wrap, [data-related]').forEach(function (el) {
    if (el.mainInit) el.mainInit.destroy();
  });
});

(function () {
  var controls = document.querySelectorAll('[data-auto-submit]');
  if (!controls.length) return;

  controls.forEach(function (el) {
    if (el.type === 'checkbox' || el.type === 'radio') {
      el.addEventListener('change', function () {
        if (el.form) el.form.submit();
      });
      return;
    }

    var pending = false;

    el.addEventListener('change', function () { pending = true; });
    el.addEventListener('blur', function () {
      if (pending && el.form) el.form.submit();
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && el.form) {
        e.preventDefault();
        el.form.submit();
      }
    });
    el.addEventListener('click', function () {
      if (pending && el.form) el.form.submit();
    });
  });
})();
